module.exports = __webpack_public_path__ + "img/dingw_icon.6d786a75.png";